export interface CheckoutDirectDebitIbanAccountDetails {
  accountName: string;
  iban: string;
}
